<template>
  <a-modal
    :visible="isOpen"
    width="95%"
    title="Work Order Insert"
    @cancel="$emit('onModalClose')"
    @ok="saveInsetItem()"
  >
    <a-button
      class="editable-add-btn"
      style="margin-bottom: 8px"
      @click="handleAdd"
    >
      Add
    </a-button>

    <a-table
      :columns="columns"
      :data-source="dataSource"
      bordered
      :pagination="false"
    >
      <template #headerCell="{ column }">
        <template v-if="['jobId', 'fgName', 'reqEnd'].includes(column.title)">
          <span style="color: #f00">*</span>
          {{ column.title }}
        </template>
      </template>
      <template #bodyCell="{ column, record, index }">
        <template
          v-if="
            ['jobId', 'poNum', 'country', 'subJobId1', 'subJobId2'].includes(
              column.dataIndex
            )
          "
        >
          <div>
            <a-input
              v-model:value="dataSource[index][column.dataIndex]"
              :placeholder="column.title"
              allowClear
            ></a-input>
          </div>
        </template>
        <template
          v-if="
            ['ecoStart', 'reqShipDate', 'reqEnd'].includes(column.dataIndex)
          "
        >
          <div>
            <a-date-picker
              show-time
              v-model:value="dataSource[index][column.dataIndex]"
              format="MM/DD HH:mm"
            />
          </div>
        </template>
        <template v-if="column.dataIndex === 'fgName'">
          <a-select v-model:value="dataSource[index].fgName">
            <a-select-option
              v-for="item in fgNameList"
              :key="item"
              :value="item"
            >
              {{ item }}
            </a-select-option>
          </a-select>
        </template>
        <template v-else-if="column.dataIndex === 'operation'">
          <a-popconfirm
            v-if="dataSource.length"
            title="Sure to delete?"
            @confirm="onDelete(record.key)"
          >
            <a>Delete</a>
          </a-popconfirm>
        </template>
      </template>
    </a-table>
  </a-modal>
</template>
<script setup>
  import { defineProps, ref, computed, watchEffect, defineEmits } from 'vue'
  import request from '@/utils/request'
  import dayjs from 'dayjs'
  import { message } from 'ant-design-vue'
  import { deepClone } from '@/utils'
  const props = defineProps({
    isOpen: Boolean,
    fgNameList: {
      default: () => {
        return []
      },
      type: Array,
    },
  })
  const emits = defineEmits()
  const dataSource = ref([])
  const columns = [
    {
      title: 'jobId',
      dataIndex: 'jobId',
      width: '8%',
    },
    {
      title: 'poNum',
      dataIndex: 'poNum',
      width: '8%',
    },
    {
      title: 'country',
      dataIndex: 'country',
      width: '8%',
    },
    {
      title: 'fgName',
      dataIndex: 'fgName',
      width: '8%',
    },
    {
      title: 'reqQuantity',
      dataIndex: 'reqQuantity',
      width: '8%',
    },
    {
      title: 'ecoStart',
      dataIndex: 'ecoStart',
      width: '11%',
    },
    {
      title: 'reqShipDate',
      dataIndex: 'reqShipDate',
      width: '11%',
    },
    {
      title: 'reqEnd',
      dataIndex: 'reqEnd',
      width: '11%',
    },
    {
      title: 'subJobId1',
      dataIndex: 'subJobId1',
      width: '9%',
    },
    {
      title: 'subJobId2',
      dataIndex: 'subJobId2',
      width: '9%',
    },
    {
      title: 'Operation',
      dataIndex: 'operation',
      width: '9%',
    },
  ]
  watchEffect(() => {
    if (props.isOpen) {
      dataSource.value = [
        {
          key: '0',
          jobId: '',
          poNum: null,
          country: '',
          fgName: props.fgNameList[0],
          reqQuantity: 1,
          ecoStart: null,
          reqShipDate: null,
          reqEnd: dayjs(),
          subJobId1: '',
          subJobId2: '',
        },
      ]
    }
  })
  const count = computed(() => dataSource.value.length + 1)
  const handleAdd = () => {
    const newData = {
      key: `${count.value}`,
      jobId: '',
      poNum: null,
      country: '',
      fgName: props.fgNameList[0],
      reqQuantity: 1,
      ecoStart: null,
      reqShipDate: null,
      reqEnd: dayjs(),
      subJobId1: '',
      subJobId2: '',
    }
    dataSource.value.push(newData)
  }
  const onDelete = (key) => {
    dataSource.value = dataSource.value.filter((item) => item.key !== key)
  }
  const saveInsetItem = () => {
    if (dataSource.value.length === 0) {
      message.warning('不能提交空表单')
      return
    } else {
      const incompleteForm = []
      dataSource.value.forEach((item, index) => {
        if (!item.jobId || !item.fgName || !item.reqEnd) {
          incompleteForm.push({ row: index + 1, ...item })
        }
      })

      if (incompleteForm.length) {
        message.error(`第${incompleteForm[0].row}行有必填项未填写，请检查`)
        return
      }
      const c = deepClone(dataSource.value)
      const rawData = c.map((list, index) => {
        list.reqEnd = dataSource.value[index].reqEnd
          ? dayjs(dataSource.value[index].reqEnd).valueOf()
          : 0
        list.reqShipDate = dataSource.value[index].reqShipDate
          ? dayjs(dataSource.value[index].reqShipDate).valueOf()
          : null
        list.ecoStart = dataSource.value[index].ecoStart
          ? dayjs(dataSource.value[index].ecoStart).valueOf()
          : null
        return list
      })
      request({
        url: 'api/schedule/insertOrderMain',
        method: 'post',
        data: {
          orderList: rawData,
        },
      }).then(() => {
        message.success('Success!!!').then(() => {
          emits('onModalClose')
        })
      })
    }
  }
</script>
<style lang="less" scoped>
  :deep(.ant-table) {
    .ant-input-affix-wrapper {
      padding: 5px 0;
      border: none;
    }
    .ant-table-thead {
      th {
        padding: 5px;
      }
    }
    .ant-table-tbody {
      td {
        padding: 2px 5px;
      }
    }
  }
</style>
